export const SIDEBAR_SPACING = {
  MAX: 32,
  MIN: 11,
} as const

export const SIDEBAR_PADDING = 2

export const OUTLET_MAX_WIDTH = 3840 // px
